import { CardMedia, Typography } from "@material-ui/core";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";

import icon from "../../../assets/icons/success.svg";
import { Button } from "../../../components/Button";
import { Heading } from "../../../components/Heading";
import { removeAllImages } from "../../../components/ImageUploader/images.slice";
import { FormType } from "../../../components/enums";
import {
  selectFormType,
  setFooterVisibility,
} from "../../../components/formSettings.slice";
import { useHideFooter, usePreventRefresh } from "../../../hooks";
import { handleBackToWelcomeRedirect } from "../../../router/utilities";
import { resetIncidentData } from "../../AC/Incident/incident.slice";
import { resetPerpetratorData } from "../../AC/Perpetrator/perpetrator.slice";
import { resetSummaryData } from "../../AC/Summary/summary.slice";
import { GenericScreen } from "../../GenericScreen";
import { resetSender } from "../sender.slice";

import styles from "./Success.module.scss";

export const SendingSuccess = (): JSX.Element => {
  useHideFooter();
  const dispatch = useDispatch();
  const formType = useSelector(selectFormType);
  const url = handleBackToWelcomeRedirect[formType];

  const handleBackToWelcome = () => {
    if (formType === FormType.AC) {
      dispatch(resetIncidentData());
      dispatch(resetPerpetratorData());
      dispatch(resetSummaryData());
      dispatch(removeAllImages());
    }
    dispatch(resetSender());
    dispatch(setFooterVisibility(true));
    dispatch(push(url));
    localStorage.removeItem("DamageNumber");
    //JIRA LPPLWEBMOB-750
    localStorage.removeItem("FormStartFromWelcome");
  };
  usePreventRefresh();

  //JIRA LPPLWEBMOB-682
  const DamageNumber = localStorage.getItem("DamageNumber");
  if (formType === FormType.AC) {
    return (
      <GenericScreen>
        <CardMedia component="img" src={icon} className={styles.icon} />
        <Heading
          align="center"
          color="secondary"
          component="h1"
          variant="h2"
          spacingBottom={{ xs: 4, sm: 6 }}
        >
          Dziękujemy za zgłoszenie!
          <br />
          <p className={styles.BlackSuccessMessege}>
            Twoja sprawa została zarejestrowana pod nr:
            <br />
            <b>{DamageNumber}</b> i oczekuje na weryfikację danych.
          </p>
        </Heading>
        <Typography paragraph align="center">
          Skontaktujemy się z Tobą w ciągu 72h.
        </Typography>
        <Button
          color="secondary"
          href="https://www.leaseplan.com/pl-pl/"
          spacingTop={5}
          variant="contained"
        >
          Przejdź na stronę Ayvens
        </Button>
        <Button
          color="secondary"
          onClick={handleBackToWelcome}
          spacingTop={5}
          variant="contained"
        >
          Zgłoś kolejną szkodę na tym pojeździe
        </Button>
      </GenericScreen>
    );
  } else {
    return (
      <GenericScreen>
        <CardMedia component="img" src={icon} className={styles.icon} />
        <Heading
          align="center"
          color="secondary"
          component="h1"
          variant="h2"
          spacingBottom={{ xs: 4, sm: 6 }}
        >
          Dziękujemy za zgłoszenie!
          <br />
          <p className={styles.BlackSuccessMessege}>
            Twoja sprawa została zarejestrowana pod nr:
            <br />
            <b>{DamageNumber}</b> i oczekuje na weryfikację danych.
          </p>
        </Heading>
        <Typography paragraph align="center">
          Skontaktujemy się z Tobą w ciągu 72h.
        </Typography>
        <Button
          color="secondary"
          href="https://www.leaseplan.com/pl-pl/"
          spacingTop={5}
          variant="contained"
        >
          Przejdź na stronę Ayvens
        </Button>
      </GenericScreen>
    );
  }
};
